import type { VoicePreference } from '../../services/cxone-sdk.service';
import { getConfig } from './get-config.util';

export function shouldShowVoicePreferenceSelector(): boolean {
  return getConfig<boolean>({
    configName: 'voice.showVoicePreferenceSelector',
    defaultValue: false,
  });
}

export function getDefaultWebRtcVoicePreference(): VoicePreference {
  return { type: 'softphone' };
}

export function resolveVoicePreferenceForConnection(
  stored: VoicePreference | null
): VoicePreference | null {
  if (stored) {
    return stored;
  }

  if (shouldShowVoicePreferenceSelector()) {
    return null;
  }

  return getDefaultWebRtcVoicePreference();
}
